import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["xlink:href"]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  name: string,
  title?: string
}




const iconPath = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  let icon = require(`@/assets/icons/${props.name}.svg`);
  if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
    icon = icon.default;
  }

  return icon.url;
})

const className = computed(() => {
  return 'inline-block align-top svg-icon svg-icon--' + props.name;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(_unref(className)),
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    (props.title)
      ? (_openBlock(), _createElementBlock("title", _hoisted_1, _toDisplayString(props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("use", {
      "xlink:href": _unref(iconPath),
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }, null, 8, _hoisted_2)
  ], 2))
}
}

})